import React, { useState, useEffect } from 'react';

import { NoFreeTrialReport } from './NoFreeTrialReport';

import { Loader } from '../../../components/Elements/Loader';

import { LENDERS_LOGO_OBJ } from '../../../components/RatesSummary/Logos';

import { comprehensiveReportSummary } from '../../../constants/Pages/FreeTrialReport';

import './FreeTrialReportOverview.css';

export const FreeTrialReportOverview = ({ freeTrialReport, loading }) => {
  const [isLocateFreeTrialModalOpen, setIsLocateFreeTrialModalOpen] = useState(false);

  useEffect(() => {
    if (!freeTrialReport) {
      setIsLocateFreeTrialModalOpen(true);
    }
  }, [freeTrialReport]);

  const handleModalPopup = (openOrClose) => {
    setIsLocateFreeTrialModalOpen(openOrClose);
  };

  if (loading) {
    return (
      <div className="loader-wrapper">
        <Loader size={50} />
      </div>
    );
  }

  if (!freeTrialReport) {
    return (
      <NoFreeTrialReport
        loading={loading}
        handleModalPopup={handleModalPopup}
        isLocateFreeTrialModalOpen={isLocateFreeTrialModalOpen}
      />
    );
  }

  const { lenderName, fromDate, toDate } = freeTrialReport.templateData;

  const [from_year, from_month, from_day] = fromDate.split('-').map(Number);

  const from_date = new Date(from_year, from_month - 1, from_day);

  const [to_year, to_month, to_day] = toDate.split('-').map(Number);

  const to_date = new Date(to_year, to_month - 1, to_day);

  return (
    <div className="free-trial-report-overview">
      <div className="free-trial-lender-logo-wrapper">
        <img
          src={LENDERS_LOGO_OBJ[lenderName.trim()]}
          className="lender-logo-img"
          alt={lenderName}
          width="500"
        />
      </div>
      <div className="comprehensive-report-summary-wrapper"> {comprehensiveReportSummary} </div>
      <div className="from-date-wrapper">From: {from_date.toDateString()}</div>
      <div className="to-date-wrapper">To: {to_date.toDateString()}</div>
    </div>
  );
};
